import { Dispatch, useEffect } from "react";
import { IStoreType } from "../types";
import { ACTIONS } from "../reducer";
import { getMPEmail } from "../utils/getMPEmail";

interface MPInfoProps {
  dispatch: Dispatch<IStoreType>;
  postcode: string;
}

const headers: HeadersInit = {
  "Content-Type": "application/json",
};

export const useGetMPInfo = async ({ dispatch, postcode }: MPInfoProps) => {
  const formattedPostcode = postcode.replace(" ", "%20");
  const url = `https://members-api.parliament.uk/api/Location/Constituency/Search?searchText=${formattedPostcode}&skip=0&take=20`;

  useEffect(() => {
    if (!postcode) return;

    const options: RequestInit = {
      method: "GET",
      headers,
      mode: "cors",
    };

    fetch(url, options)
      .then((response) => response.json())
      .then(async (result) => {
        if (result.items.length === 0) {
          dispatch({
            type: ACTIONS.FETCH_MP_ERROR,
            payload: "Could not match MP to your postcode.",
          });
          return;
        } else {
          const { member } = result.items[0].value.currentRepresentation;

          dispatch({
            type: ACTIONS.FETCH_MP_SUCCESS,
            payload: {
              name: member.value.nameDisplayAs,
              party: member.value.latestParty.name,
              constituency: result.items[0].value.name,
              email: result.items[0].email,
              thumbnail: member.value.thumbnailUrl,
            },
          });

          const mpEmail = await getMPEmail(
            result.items[0].value.currentRepresentation.member.value.id
          );

          dispatch({
            type: ACTIONS.FETCH_MP_EMAIL_SUCCESS,
            payload: mpEmail,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: ACTIONS.FETCH_MP_ERROR,
          payload: error,
        });
      });
  }, [dispatch, postcode, url]);
};
